module.exports = __webpack_public_path__ + "static/2-783c45d75b4980e28fd888f6db1ba6de.png";